import { ServiceFactory } from '../../../../../services/ServiceFactory';
import { CreateQuoteRequest } from '../../../../../types/quotes/quoteRequest';

export const sendQuoteRequest = async (payload: CreateQuoteRequest) => {
  const quotesApi = ServiceFactory.createQuotesService();
  return quotesApi.createQuote(payload);
};
